import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { ApplicationFormAction } from "./../../redux/actions";
import { getLangLat } from "./../../apis/tutors";
import {
  Col,
  Row,
  DropdownButton,
  Dropdown,
  Image,
  Spinner,
  Modal,
} from "react-bootstrap";
import { debounce } from "lodash";
import warning from "../../assets/icons/warning.png";

const TutoringModeModal = (props) => {
  const [state, updateState] = useState({
    modeOfTeaching: 2,
    address: {
      address1: "",
      address2: "",
      apartment: "",
      city: "",
      country: "",
      postCode: "",
    },
    errors: {
      address1: "",
      city: "",
      postCode: "",
      willignessToTravel: "",
    },
    postCodeArray: [],
    searchmode: false,
    postcodeLoader: false,
    willignessToTravel: "",
  });

  const validate = () => {
    let errors = state.errors;
    const { address, modeOfTeaching, willignessToTravel } = state;

    if (modeOfTeaching !== 0) {
      if (willignessToTravel === undefined || willignessToTravel === "") {
        errors.willignessToTravel = "Please select distance";
      }

      if (
        address?.address1 === undefined ||
        address?.address1 === "" ||
        address?.address1?.length > 35
      ) {
        errors.address1 = "Please enter a maximum of 35 characters.";
      }

      if (address?.city === undefined || address?.city === "") {
        errors.city = "Please enter a your City or Town.";
      }

      if (address?.postCode === undefined || address?.postCode === "") {
        errors.postCode = "Please enter a valid postcode.";
      }

      updateState({ ...state, errors: errors });

      if (
        errors?.willignessToTravel === "" &&
        errors?.address1 === "" &&
        errors?.city === "" &&
        errors?.postCode === ""
      ) {
        SaveAndCancel();
      }
    } else SaveAndCancel();
  };

  const handleInputChange = (event) => {
    let address = state.address;
    address[event.target.name] = event.target.value;
    updateState({ ...state, address });
    if (event.target.name === "postCode") {
      getPostCode(event.target.value);
    }
  };

  const handleFocus = (field) => {
    let errors = state.errors;
    errors[field] = "";
    updateState({ ...state, errors: errors });
  };

  const selectMode = (value) => {
    updateState({
      ...state,
      modeOfTeaching: value,
    });
  };

  useEffect(() => {
    let modeOfTeaching = props?.TutorInfoObj?.step1?.modeOfTeaching;
    let willignessToTravel = props?.TutorInfoObj?.step1?.willignessToTravel;
    let address = props?.TutorInfoObj?.step1?.address
      ? props?.TutorInfoObj?.step1?.address
      : {};
    updateState((state) => ({
      ...state,
      modeOfTeaching:
        modeOfTeaching === 0 || modeOfTeaching ? modeOfTeaching : 2,
      willignessToTravel,
      street: address?.street,
      town: address?.town,
      country: address?.country,
      postCode: address?.postCode,
      address: address,
    }));
  }, [props?.TutorInfoObj]);

  const getPostCode = debounce((text) => {
    updateState({
      ...state,
      postcodeLoader: true,
    });
    let isInputFieldEmptyRE = /^\s*$/;
    if (!isInputFieldEmptyRE.test(text)) {
      fetch(`https://api.postcodes.io/postcodes/${text}/autocomplete`)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (response.status === 200) {
            updateState({
              ...state,
              postCodeArray: response.result,
              searchmode: true,
              postcodeLoader: false,
            });
          }
        })
        .catch((error) => {
          updateState({
            ...state,
            postcodeLoader: false,
          });
        });
    } else {
      updateState({
        ...state,
        searchmode: false,
        postcodeLoader: false,
        postCodeArray: [],
      });
    }
  }, 200);

  /*this api for after user*/

  const SaveAndCancel = () => {
    const { modeOfTeaching, address, willignessToTravel } = state;

    let address1 = address?.address1 ? address?.address1 + ", " : "";
    let address2 = address?.address2 ? address?.address2 + ", " : "";
    let apartment = address?.apartment ? address?.apartment + ", " : "";
    let city = address?.city ? address?.city + ", " : "";
    let country = address?.country ? address?.country + ", " : "";
    let postCode = address?.postCode ? address?.postCode : "";

    let TutorInfoObj = props?.TutorInfoObj ? props?.TutorInfoObj : {};
    let step1 = {
      subjects: TutorInfoObj?.step1?.subjects,
      modeOfTeaching: modeOfTeaching,
      address: address,
      willignessToTravel: willignessToTravel ? willignessToTravel : "",
      addressLatLng: [],
      addressRaw:
        modeOfTeaching !== 0
          ? `${address1}${apartment}${address2}${city}${country}${postCode}`
          : "",
    };
    if (modeOfTeaching !== 0) {
      getLangLat(
        `${address.address1},${address.city},${address.country},${address.postCode}`
      )
        .then((res) => {
          step1.addressLatLng.push(res.results[0].locations[0].latLng.lat);
          step1.addressLatLng.push(res.results[0].locations[0].latLng.lng);
          props.AddTutorInfo({ step1 });
          props.onclose();
        })
        .catch((err) => console.log(err));
    } else {
      props.AddTutorInfo({ step1 });
      props.onclose();
    }
  };

  const {
    modeOfTeaching,
    willignessToTravel,
    errors,
    address,
    postCodeArray,
    searchmode,
    postcodeLoader,
  } = state;
  const {
    validationError,
    tutoringModeModal,
    onclose,
    iscompletedForm,
  } = props;

  let warningAddress1, warningCity, warningPostCode, warningWillignessToTravel;

  if (errors.address1 !== "") {
    warningAddress1 = (
      <img
        src={warning}
        alt="warning"
        width="14px"
        height="14px"
        style={{ marginRight: "6px" }}
      />
    );
  }

  if (errors.city !== "") {
    warningCity = (
      <img
        src={warning}
        alt="warning"
        width="14px"
        height="14px"
        style={{ marginRight: "6px" }}
      />
    );
  }

  if (errors.postCode !== "") {
    warningPostCode = (
      <img
        src={warning}
        alt="warning"
        width="14px"
        height="14px"
        style={{ marginRight: "6px" }}
      />
    );
  }

  if (errors.willignessToTravel !== "") {
    warningWillignessToTravel = (
      <img
        src={warning}
        alt="warning"
        width="14px"
        height="14px"
        style={{ marginRight: "6px" }}
      />
    );
  }

  return (
    <Modal
      size="lg"
      centered
      className="Modal"
      show={tutoringModeModal}
      onHide={onclose}
    >
      <Row className="ModeForTeach-Col flex-center-center">
        <Col lg={12} md={12} sm={12} xs={12} className="modal-content">
          <Row className="header">
            <Col lg={12} md={12} sm={12} xs={12} className="modal-title">
              <p className="header_options">Select mode for teaching</p>
            </Col>
          </Row>
          <div style={{ borderBottom: "1px solid #00000033" }} />
          <Row className="ModeForTeach-body">
            <Col
              lg={5}
              md={12}
              sm={12}
              xs={12}
              className="green-radio-custom flex-center-center"
            >
              <div
                className="custom-control custom-radio"
                onClick={() => selectMode(2)}
              >
                <input
                  type="radio"
                  id="customRadioInline1"
                  name="customRadioInline1"
                  className="custom-control-input"
                  checked={modeOfTeaching === 2 ? true : false}
                />
                <label
                  className="custom-control-label"
                  htmlFor="customRadioInline1"
                >
                  Online and In-person
                </label>
              </div>
            </Col>
            <Col
              lg={3}
              md={12}
              sm={12}
              xs={12}
              className="green-radio-custom flex-center-center"
            >
              <div
                className="custom-control custom-radio"
                onClick={() => selectMode(0)}
              >
                <input
                  type="radio"
                  id="customRadioInline2"
                  name="customRadioInline1"
                  className="custom-control-input"
                  checked={modeOfTeaching === 0 ? true : false}
                />
                <label
                  className="custom-control-label"
                  htmlFor="customRadioInline2"
                >
                  Online
                </label>
              </div>
            </Col>
            <Col
              lg={4}
              md={12}
              sm={12}
              xs={12}
              className="green-radio-custom flex-center-center"
            >
              <div
                className="custom-control custom-radio"
                onClick={() => selectMode(1)}
              >
                <input
                  type="radio"
                  id="customRadioInline3"
                  name="customRadioInline1"
                  className="custom-control-input"
                  checked={modeOfTeaching === 1 ? true : false}
                />
                <label
                  className="custom-control-label"
                  htmlFor="customRadioInline3"
                >
                  In-person
                </label>
              </div>
            </Col>
          </Row>
          {(modeOfTeaching === 1 || modeOfTeaching === 2) && (
            <Row style={{ margin: "0px", padding: "0px 23px", width: "100%" }}>
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{
                  margin: "0px",
                  padding: "0px",

                  fontFamily: "Arial, Helvetica, sans-serif",
                  fontSize: "16px",
                  fontWeight: "normal",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: "1.36",
                  letterSpacing: "normal",
                  textAlign: "left",
                  color: "#0f0f0f",
                }}
              >
                <p>
                  If you will be teaching in-person, how far you willing to
                  travel from your address to teach the student.
                </p>
              </Col>
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="ModeForTeach-body-down"
              >
                <DropdownButton
                  id="dropdown-basic-button"
                  onFocus={() => handleFocus("willignessToTravel")}
                  title={
                    <span
                      className={errors?.willignessToTravel ? "errorInput" : ""}
                    >
                      {willignessToTravel ? willignessToTravel : "Distance"}
                      <Image
                        style={{ width: "15px" }}
                        src={require("./../../assets/icons/down-arrow.png")}
                      />
                    </span>
                  }
                >
                  <Dropdown.Item
                    eventkey="I only teach at my address"
                    className="dropdown-items"
                    onClick={() =>
                      updateState({
                        ...state,
                        willignessToTravel: "I only teach at my address",
                      })
                    }
                  >
                    I only teach at my address
                  </Dropdown.Item>
                  <Dropdown.Item
                    eventKey="1 miles"
                    className="dropdown-items"
                    onClick={() =>
                      updateState({ ...state, willignessToTravel: "1 miles" })
                    }
                  >
                    1 miles
                  </Dropdown.Item>
                  <Dropdown.Item
                    eventKey="2 miles"
                    className="dropdown-items"
                    onClick={() =>
                      updateState({ ...state, willignessToTravel: "2 miles" })
                    }
                  >
                    2 miles
                  </Dropdown.Item>
                  <Dropdown.Item
                    eventKey="10 miles"
                    className="dropdown-items"
                    onClick={() =>
                      updateState({ ...state, willignessToTravel: "10 miles" })
                    }
                  >
                    10 miles
                  </Dropdown.Item>
                  <Dropdown.Item
                    eventKey="15 miles"
                    className="dropdown-items"
                    onClick={() =>
                      updateState({ ...state, willignessToTravel: "15 miles" })
                    }
                  >
                    15 miles
                  </Dropdown.Item>
                  <Dropdown.Item
                    eventKey="20 miles"
                    className="dropdown-items"
                    onClick={() =>
                      updateState({ ...state, willignessToTravel: "20 miles" })
                    }
                  >
                    20 miles
                  </Dropdown.Item>
                </DropdownButton>
                <div className="error">
                  {warningWillignessToTravel}
                  {errors?.willignessToTravel}
                </div>

                <div style={{ padding: "1px" }}>
                  <div className="Ques-txt">What is your address?</div>
                  <div className="para-txt">
                    If you teach from home this will only be provided to
                    students and parent's once you have accepted booking
                  </div>

                  <div className="floating-label">
                    <input
                      type="text"
                      id="address1"
                      name="address1"
                      placeholder="Address line 1"
                      onChange={(e) => handleInputChange(e)}
                      disabled={!iscompletedForm ? false : true}
                      onFocus={(e) => handleFocus(e.target.name)}
                      className={errors?.address1 ? "errorInput" : ""}
                      value={address?.address1 ? address?.address1 : ""}
                    />
                    <label className={errors?.address1 ? "label" : ""}>
                      Address line 1
                    </label>
                  </div>
                  <div className="error">
                    {warningAddress1}
                    {errors?.address1}
                  </div>

                  <div className="floating-label">
                    <input
                      type="text"
                      id="apartment"
                      name="apartment"
                      placeholder="Apartment, Suite, Building Access Code (Optional)"
                      onChange={(e) => handleInputChange(e)}
                      disabled={!iscompletedForm ? false : true}
                      onFocus={(e) => handleFocus(e.target.name)}
                      value={address?.apartment ? address?.apartment : ""}
                    />
                    <label>
                      Apartment, Suite, Building Access Code (Optional)
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      type="text"
                      id="address2"
                      name="address2"
                      placeholder="Address line 2"
                      onChange={(e) => handleInputChange(e)}
                      disabled={!iscompletedForm ? false : true}
                      onFocus={(e) => handleFocus(e.target.name)}
                      value={address?.address2 ? address?.address2 : ""}
                    />
                    <label>Address line 2</label>
                  </div>

                  <div className="floating-label">
                    <input
                      type="text"
                      id="city"
                      name="city"
                      placeholder="City or Town"
                      onChange={(e) => handleInputChange(e)}
                      disabled={!iscompletedForm ? false : true}
                      onFocus={(e) => handleFocus(e.target.name)}
                      className={errors?.city ? "errorInput" : ""}
                      value={address?.city ? address?.city : ""}
                    />
                    <label className={errors?.city ? "label" : ""}>
                      City or Town
                    </label>
                  </div>
                  <div className="error">
                    {warningCity}
                    {errors?.city}
                  </div>

                  <Row>
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <div className="floating-label">
                        <input
                          type="text"
                          id="country"
                          name="country"
                          placeholder="County (Optional)"
                          onChange={(e) => handleInputChange(e)}
                          disabled={!iscompletedForm ? false : true}
                          onFocus={(e) => handleFocus(e.target.name)}
                          value={address?.country ? address?.country : ""}
                        />
                        <label>County (Optional)</label>
                      </div>
                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12}>
                      <div className="floating-label">
                        <input
                          type="text"
                          id="postCode"
                          name="postCode"
                          placeholder="Postcode"
                          onChange={(e) => handleInputChange(e)}
                          disabled={!iscompletedForm ? false : true}
                          onFocus={(e) => handleFocus(e.target.name)}
                          className={errors?.postCode ? "errorInput" : ""}
                          value={address?.postCode ? address?.postCode : ""}
                        />
                        <label className={errors?.postCode ? "label" : ""}>
                          Postcode
                        </label>
                      </div>
                      <div className="error">
                        {warningPostCode}
                        {errors?.postCode}
                      </div>

                      <div
                        style={{
                          display:
                            postcodeLoader ||
                            searchmode ||
                            postCodeArray?.length
                              ? "flex"
                              : "none",
                        }}
                        className={
                          postcodeLoader || searchmode || postCodeArray?.length
                            ? "postcode-list-div"
                            : ""
                        }
                      >
                        {!postcodeLoader ? (
                          searchmode && postCodeArray?.length ? (
                            postCodeArray.map((post, index) => (
                              <p
                                key={index}
                                style={{ cursor: "pointer", margin: "0px" }}
                                onClick={() => {
                                  address.postCode = post;
                                  updateState({
                                    ...state,
                                    address,
                                    postCodeArray: [],
                                    postcodeLoader: false,
                                    searchmode: false,
                                  });
                                }}
                              >
                                <div className="flex-start-center post-value">
                                  <Image
                                    className="img"
                                    src={require("./../../assets/icons/gps.png")}
                                  />
                                  <span>{post}</span>
                                </div>
                              </p>
                            ))
                          ) : (
                            "no post code"
                          )
                        ) : (
                          <div className="flex-center-center p-3">
                            <Spinner
                              animation="border"
                              style={{ width: "25px", height: "25px" }}
                            />
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          )}

          <div
            style={{ borderBottom: "1px solid #00000033", marginTop: "51px" }}
          />

          <div className="modal-footer">
            <div className="row flex-center" style={{ width: "100%" }}>
              <div className="col-6 text-left">
                <button className="cancel" onClick={onclose}>
                  Cancel
                </button>
              </div>
              <div className="col-6 text-right">
                <button className="btn-save" onClick={validate}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const {
    ApplicationFormReducer: { TutorInfoObj, validationError },
  } = state;

  return {
    TutorInfoObj,
    validationError,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    AddTutorInfo: (payload) =>
      dispatch(ApplicationFormAction.AddTutorInfo(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TutoringModeModal);
